module.exports = __webpack_public_path__ + "static/media/loading.c0575cdf.gif";